import React, { useEffect, useState } from 'react';
// import HeaderSCI from './HeaderSCI';
import HeaderSCI from './HeaderSCI';
// import HeaderSCI from '../ControlInterno/HeaderSCI';
import './recursocontable.css';
import './armonizacionContable.css';
const principios = [
  {
    id: 1,
    color: '#621132',
    title: "Ejercicio fiscal 2025.",
    items: [

       {
        label: "Ingresos",
        
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1%C2%B0_Informe_Trimestral_2025.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2do_Informe_Trimestral_2025.pdf"
          },
          {
            label: "3ro. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/Estado%20Anal%C3%ADtico%20de%20Ingresos%20Presupuestales2025.pdf"
          },
        
        ]
      },
       {
        label: "Egresos",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1%C2%B0_Informe_Trimestral_Egreso2025.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2do_Informe_Trimestral_Egreso2025.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/ESTADO%20DE%20PRESUPUESTO%205%20AL%20MILLAR%20ESTATALE2025.pdf"
          }
        ]
      },
   
   
   
      
     
    ]
  },

 {
    id: 2,
    color: '#9e2348',
    title: "Ejercicio fiscal 2024.",
     items: [

       {
        label: "Ingresos",
        
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1er_TRIMESTRE_INGRESOS_5M_ESTATAL_2024.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2do_TRIMESTRE_INGRESOS_5M_ESTATAL_2024.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3er._Informe_Trimestral_de_Ingresos_5M_Estatal_2024.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4to._Informe_Trimestral_de_Ingresos_5M_Estatal_2024.pdf"
          },
          {
            label: "INFORME ANUAL INGRESOS 5M ESTATAL 2024",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_INGRESOS_5M_ESTATAL_2024.pdf"
          }          
        ]
      },
       {
        label: "Egresos",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1er_TRIMESTRE_EGRESOS_5M_ESTATAL_2024.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2do_TRIMESTRE_EGRESOS_5M_ESTATAL_2024.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3er._Informe_Trimestral_de_Egresos_5M_Estatal_2024.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4to._Informe_Trimestral_de_Egresos_5M_Estatal_2024.pdf"
          },
          {
            label: "INFORME ANUAL EGRESOS 5M ESTATAL 2024",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_EGRESOS_5M_ESTATAL_2024.pdf"
          },
         
        ]
      },
    
    
     
    ]
  },
  {
    id: 3,
    color: '#a98188',
    title: "Ejercicio fiscal 2023.",
     items: [


              {
        label: "Ingresos",
        
        subitems: [
            {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_INGRESOS_5M_ESTATAL_2023.pdf"
          },

           
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_INGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_INGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_INGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_EGRESOS_5M_ESTATAL_2023.pdf"
          }
         
        ]
      },
       {
        label: "Egresos",
        subitems: [
           
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1er_TRIMESTRE_EGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2do_TRIMESTRE_EGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3er_TRIMESTRE_EGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4to_TRIMESTRE_EGRESOS_5M_ESTATAL_2023.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_EGRESOS_5M_ESTATAL_2023%20(1).pdf"
          },
        
        ]
      },
            
     
    ]
  },
{
    id:4,
    color: '#a98188',
    title: "Ejercicio fiscal 2022.",
     items: [

        {
        label: "Ingresos",
        
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_INGRESOS_ESTATAL_2022.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_INGRESOS_ESTATAL_2022.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_INGRESOS_ESTATAL_2022.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_INGRESOS_ESTATAL_2022.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_INGRESOS_5M_ESTATAL_2022.pdf"
          },
                   
        ]
      },
       {
        label: "Egresos",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_EGRESOS_5M_ESTATAL_2022.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_EGRESOS_5M_ESTATAL_2022.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_EGRESOS_5M_ESTATAL_2022.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_EGRESOS_5M_ESTATAL_2022.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_ANUAL_EGRESOS_5M_ESTATAL_2022.pdf"
          },
          

      
        ]
      },
     
     
     
      
     
    ]
  },
  {
    id:5,
    color: '#a98188',
    title: "Ejercicio fiscal 2021.",
     items: [
      

        {
        label: "Ingresos",
              
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_INGRESOS_2021.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_INGRESOS_ESTATAL_2021.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_INGRESOS_ESTATAL_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_INGRESOS_ESTATAL_2021.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_INGRESOS_ANUAL_ESTATAL_2021.pdf"
          },
         
        ]
      },
       {
        label: "Egresos",
        subitems: [
          // {
          //   label: "Enero",
          //   url: "/micro/principio1/codigo_etica_2025.pdf"
          // },
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_EGRESOS_2021.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_EGRESOS_5M_ESTATAL_2021.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_EGRESOS_5M_ESTATAL_2021.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_EGRESOS_5M_ESTATAL_2021.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/INFORME_EGRESOS_ANUAL_5M_ESTATAL_2021.pdf"
          },
        

        ]
      },
     
     
 
      
     
    ]
  },

   {
    id:6,
    color: '#a98188',
    title: "Ejercicio fiscal 2020",
     items: [

       {
        label: "Ingresos",
        
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_INGRESOS_2020.pdf",
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_INGRESOS_2020.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_INGRESOS_2020.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_INGRESOS_2020.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/ANUAL_INGRESOS_2020.pdf"
          },
         
        ]
      },
       {
        label: "Egresos",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_EGRESOS_2020.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_EGRESOS_2020.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_EGRESOS_2020.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO%20TRIMESTRE%20EGRESOS%202020.pdf"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/ANUAL_EGRESOS_2020.pdf"
          },

        
        ]
      },
     
    

      
     
    ]
  },

 {
    id:7,
    color: '#a98188',
    title: "Ejercicio fiscal 2019",
     items: [

       {
        label: "Ingresos",
        
        
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_INGRESOS_2019.pdf",
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_INGRESOS_2019.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_INGRESOS_2019.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_INGRESOS_2019"
          },
          {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/ANUAL_INGRESOS_2019.pdf"
          },
         
        ]
      },
       {
        label: "Egresos",
        subitems: [
          {
            label: "1er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/1ER_TRIMESTRE_EGRESOS_2019.pdf"
          },
          {
            label: "2do. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/2DO_TRIMESTRE_EGRESOS_2019.pdf"
          },
          {
            label: "3er. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/3ER_TRIMESTRE_EGRESOS_2019.pdf"
          },
          {
            label: "4to. Informe Trimestral",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/4TO_TRIMESTRE_EGRESOS_2019.pdf"
          },
           {
            label: "Informe Anual",
            url: "https://s-contraloria.hidalgo.gob.mx/descargables/ANUAL_EGRESO_%202019.pdf"
          },

        
        ]
      },
     
    

      
     
    ]
  },



];

const RecursoContable = () => {
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const toggleAccordion = (id) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  return (
    <>
    

      <div className="container ci-nav pt-4">
        {/* Title pill */}
        <div className="row justify-content-center mb-4">
          <div className="col-12 col-md-5 d-flex justify-content-center">
            <div className="ci-nav__btn--pill" style={{ cursor: 'default', margin: 0 }}>
              Recurso Estatal 5 al Millar
            </div>
          </div>
        </div>

        {/* Text Description */}
        <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-10">
            <p className="ci-desc-text">
             EJERCICIOS
            </p>
          </div>
        </div>

        {/* Accordion / Toggle List */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            {principios.map((prin) => {


              const isExpanded = expandedId === prin.id;

              return (
                <div key={prin.id} className="mb-2">
                  {/* Header Button */}
                  <div 
                    className="ci-nav__btn ci-nav__btn--doc" 
                    onClick={() => toggleAccordion(prin.id)}
                    style={{ cursor: 'pointer', padding: '8px 12px' }}
                  >
                    <div className="ci-nav__icon" style={{ backgroundColor: prin.color }}>
                      <i className="fa-solid fa-id-card"></i>
                    </div>
                    <span className="ci-nav__label ci-nav__label--doc" style={{ fontSize: '1rem', color: '#621132' }}>
                      {prin.title}
                    </span>
                  </div>

                  {/* Expanded Content */}
                  <div className={`ci-accordion-wrapper ${isExpanded ? 'is-open' : ''}`}>
                    <div className="ci-accordion-inner">
                      {/* {prin.items.length > 0 ? (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <ul style={{ color: prin.color, fontSize: '0.95rem', fontStyle: 'italic', lineHeight: '1.6' }}>
                            {prin.items.map((item, idx) => (
                                <li key={idx} className="mb-2">
                                  <a 
                                    href={item.url || "#"}
                                    target={item.url ? "_blank" : "_self"}
                                    rel={item.url ? "noopener noreferrer" : ""}
                                    style={{ color: '#621132' }}
                                  >
                                    {item.label}
                                  </a>
                                </li>
                              ))}
                         </ul>
                        </div>
                      )  */}

                      {prin.items.map((item, idx) => (
                      <li key={idx} className="mb-2">
                        {item.subitems ? (
                          <>
                            <strong style={{ color: '#621132' }}>
                              {item.label}
                            </strong>

                            <ul style={{ marginTop: '5px', marginLeft: '20px' }}>
                              {item.subitems.map((subitem, subIdx) => (
                                <li key={subIdx}>
                                  <a
                                    href={subitem.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#9e2348' }}
                                  >
                                    {subitem.label}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </>
                        ) : (
                          <a
                            href={item.url || "#"}
                            target={item.url ? "_blank" : "_self"}
                            rel={item.url ? "noopener noreferrer" : ""}
                            style={{ color: '#621132' }}
                          >
                            {item.label}
                          </a>
                        )}
                      </li>
                    ))}
                    
                      { (
                        <div className="ci-accordion-content ps-5 mt-1 mb-2">
                          <p style={{ color: '#621132', fontSize: '0.95rem', fontStyle: 'italic' }}>
                            No hay documentos disponibles.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default RecursoContable;
